import { buyPackageInApp } from '../../../actions/webview';
import { selectLocationIds, selectOfferCategory, selectOfferCoordinates } from '../../../selectors/offer';
import { TThunkAction } from '../../../../common/types/thunk';
import { selectActiveRecommendedPackage } from '../../../reducers/v2/recommendedPackages/selectors';

export const buyPackageNativeThunk =
  (): TThunkAction =>
  (_, getState, { webview }) => {
    const state = getState();
    const { packageId, packageType } = selectActiveRecommendedPackage(state)!;
    const category = selectOfferCategory(state);
    const { lat, lng } = selectOfferCoordinates(state);
    const locationPath = selectLocationIds(state);

    webview.sendAction(
      buyPackageInApp({
        packageId,
        packageType,
        category,
        latitude: lat,
        longitude: lng,
        locationPath,
      }),
    );
  };
